import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionIdFragment } from 'graphql/surface-node/fragments/surface-node-fragment';

export const softDeleteSurfaceNodeMutation = gql`
  mutation softDeleteSurfaceNode($id: ID!) {
    softDeleteSurfaceNode(id: $id) {
      data {
        deletedSurfaceNode {
          ...surfaceNodeUnionId
        }
        references {
          ...surfaceNodeUnionId
        }
      }
      error
      success
    }
  }
  ${surfaceUnionIdFragment}
`;

export default mutation(softDeleteSurfaceNodeMutation);
